import { render, staticRenderFns } from "./AlacakKalemiDetayForm.vue?vue&type=template&id=12917eeb"
import script from "./AlacakKalemiDetayForm.vue?vue&type=script&lang=ts"
export * from "./AlacakKalemiDetayForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports